import {
  flow, observable, computed, makeObservable,
} from 'mobx';

import BaseStore from './BaseStore';
import ProductsPageAPI from '../api/products_page';
import { PARIS_CENTER } from '../constants';

const PER_PAGE_LIMIT = 6;

class ProductsPageStore extends BaseStore {
  isSchoolsDataLoading = false;
  schools = [];
  total;

  getSchoolsProducts = flow(function* ({
    latitude = PARIS_CENTER.latitude, longitude = PARIS_CENTER.longitude, limit = PER_PAGE_LIMIT, page = 1, sort_by,
  } = {}) {
    this.isSchoolsDataLoading = true;

    try {
      const { data } = yield ProductsPageAPI.getProducts(latitude, longitude, limit, page, sort_by);
      this.schools = data.schools;
      if (this.total !== data.total) {
        this.total = data.total;
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.isSchoolsDataLoading = false;
    }
  });

  constructor() {
    super();

    makeObservable(this, {
      isSchoolsDataLoading: observable,
      schools: observable,
      total: observable,
      pageCount: computed,
    });
  }

  get pageCount() {
    return Math.ceil(this.total / PER_PAGE_LIMIT);
  }
}

export default new ProductsPageStore();
